var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("img", {
      class: { show: _vm.email == "manager@donamaid.com" },
      attrs: { src: "/static/DASHBOARD_1.png" }
    }),
    _vm._v(" "),
    _c("img", {
      class: { show: _vm.email == "luiz@donamaid.com" },
      attrs: { src: "/static/DASHBOARD_1.png" }
    }),
    _vm._v(" "),
    _c("img", {
      class: { show: _vm.email == "ruben@donamaid.com" },
      attrs: { src: "/static/DASHBOARD_1.png" }
    }),
    _vm._v(" "),
    _c("img", {
      class: { show: _vm.email == "janine@donamaid.com" },
      attrs: { src: "/static/DASHBOARD_1.png" }
    }),
    _vm._v(" "),
    _c("img", {
      class: { show: _vm.email == "munique@donamaid.com" },
      attrs: { src: "/static/DASHBOARD_2.png" }
    }),
    _vm._v(" "),
    _c("img", {
      class: { show: _vm.email == "alana@donamaid.com" },
      attrs: { src: "/static/DASHBOARD_2.png" }
    }),
    _vm._v(" "),
    _c("img", {
      class: { show: _vm.email == "kellerson@donamaid.com" },
      attrs: { src: "/static/DASHBOARD_3.png" }
    }),
    _vm._v(" "),
    _c("img", {
      class: { show: _vm.email == "luiza@donamaid.com" },
      attrs: { src: "/static/DASHBOARD_3.png" }
    }),
    _vm._v(" "),
    _c("img", {
      class: { show: _vm.email == "andre@donamaid.com" },
      attrs: { src: "/static/DASHBOARD_3.png" }
    }),
    _vm._v(" "),
    _c("img", {
      class: { show: _vm.email == "danielle@donamaid.com" },
      attrs: { src: "/static/DASHBOARD_3.png" }
    }),
    _vm._v(" "),
    _c("img", {
      class: { show: _vm.email == "camila.mascarenhas@donamaid.com" },
      attrs: { src: "/static/DASHBOARD_3.png" }
    }),
    _vm._v(" "),
    _c("img", {
      class: { show: _vm.email == "erick@donamaid.com" },
      attrs: { src: "/static/DASHBOARD_4.png" }
    }),
    _vm._v(" "),
    _c("img", {
      class: { show: _vm.email == "joao@donamaid.com" },
      attrs: { src: "/static/DASHBOARD_4.png" }
    }),
    _vm._v(" "),
    _c("img", {
      class: { show: _vm.email == "gustavo@donamaid.com" },
      attrs: { src: "/static/DASHBOARD_4.png" }
    }),
    _vm._v(" "),
    _c("img", {
      class: { show: _vm.email == "guilherme@donamaid.com" },
      attrs: { src: "/static/DASHBOARD_4.png" }
    }),
    _vm._v(" "),
    _c("img", {
      class: { show: _vm.email == "camila@donamaid.com" },
      attrs: { src: "/static/DASHBOARD_4.png" }
    }),
    _vm._v(" "),
    _c("img", {
      class: { show: _vm.email == "jessica@donamaid.com" },
      attrs: { src: "/static/DASHBOARD_5.png" }
    }),
    _vm._v(" "),
    _c("img", {
      class: { show: _vm.email == "tais@donamaid.com" },
      attrs: { src: "/static/DASHBOARD_5.png" }
    }),
    _vm._v(" "),
    _c("img", {
      class: { show: _vm.email == "patrick@donamaid.com" },
      attrs: { src: "/static/DASHBOARD_5.png" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aae30ed8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aae30ed8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = null
// module chunks = 